enum RecipientAvailabilityConstants {
    Unknown = 'Unknown',
    Available = 'Available',
    Unavailable = 'Unavailable',
}

export default RecipientAvailabilityConstants;
